import Component from '../Component';

export default class Popup extends Component {
    STORAGE_KEY = 'wetheme-popup';

    constructor(theme, element) {
      super(theme, element);

      this.popupWrapper = this.element.querySelector('.popup-container');
      this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10);
      this.popupDelay = parseInt(this.element.dataset.popupDelay, 10);
      this.testMode = this.element.dataset.popupTestMode === 'true';
      this.lastFocus = document.activeElement;
      this.focusable = document.body.querySelectorAll('ul.nav li a');

      this.load();
    }

    load = () => {
      if (this.testMode) {
        // popup is in test mode - will show immediately in editor and on live site
        this.show();
      } else if (this.isExpiredOrNotSet()) {
        // popup item in localStorage is expired or was not set, show popup this time
        setTimeout(() => {
          this.setExpiry(this.popupSkipDays);
          this.show();
        }, 1000 * this.popupDelay);
      }


      this.element.querySelector('.popup--close-btn').addEventListener('click', this.hide);
    }

    isExpiredOrNotSet = () => {
      let expired = true;

      if (!this.isLocalStorageSupported(() => localStorage)) return expired;

      const popupInfo = window.localStorage.getItem(this.STORAGE_KEY);
      if (popupInfo) {
        try {
          const expiry = Date.parse(JSON.parse(popupInfo).expiry);
          if (expiry > Date.now()) {
            expired = false;
          }
        } catch (e) {
          console.warn('Unable to read popup expiry date', e);
        }
      }
      return expired;
    }

    setExpiry = (days) => {
      const expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
      try {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
          expiry: expiry.toISOString(),
        }));
      } catch (e) {
        console.warn('Unable to set popup expiry:', e);
      }
    }

    isLocalStorageSupported = (getStorage) => {
      try {
        const key = "__random_key_name___e__";
        getStorage().setItem(key, key);
        getStorage().removeItem(key);
        return true;
      } catch (e) {
        return false;
      }
    }

    show = () => {
      this.element.classList.add('visible');
      this.lastFocus = document.activeElement;
      setTimeout(this.trapFocus, 1000);
    }

    hide = () => {
      this.element.classList.remove('visible');
    }

    trapFocus = () => {
      var inputs = this.element.querySelectorAll('input:not([type=hidden]), button, a');
      var firstInput = inputs[0];
      var lastInput = inputs[inputs.length-1];
      var self = this;

      // If newsletter is there, focus on input
      if(this.element.querySelector('.popup__newsletter-form')) {
        (/** @type {HTMLElement} */ (this.element.querySelector('#newsletter_text'))).focus();
      }
      else {
        (/** @type {HTMLElement} */ (this.element.querySelector('.popup--close-btn'))).focus();
      }

      // Redirect last tab to first input
      lastInput.addEventListener('keydown', function (/** @type {KeyboardEvent} */ e) {
        if (e.code === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          (/** @type {HTMLElement} */ (firstInput)).focus();
        }
      });

      // Redirect first shift+tab to last input
      firstInput.addEventListener('keydown', function (/** @type {KeyboardEvent} */ e) {
        // First input is the close icon, so allow closing via enter key.
        if(e.code == 'Enter') {
          e.preventDefault();
          self.hide();
          (/** @type {HTMLElement} */ (self.focusable[0])).focus();
        }

        if (e.code === 'Tab' && e.shiftKey) {
          e.preventDefault();
          (/** @type {HTMLElement} */ (lastInput)).focus();
        }
      });
    }

}
